import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";
import DashboardLayout from "../layouts/DashboardLayout";
import Login from "../pages/Login";
import Home from "../pages/Home";
import NewAssessment from "../pages/NewAssessment";
import JobExplorer from "../pages/JobExplorer";
import QueryCheck from "../pages/QueryCheck";
import ConfigModel from "../pages/ConfigModel";
import ConfigCategory from "../pages/ConfigCategory";
import HallucinationCategories from "../pages/HallucinationCategories";

import RailLogs from "../pages/RailLogs";
import AssessmentReport from "../pages/AssessReport";
import RailConfig from "../pages/RailConfig";
import RailTesting from "../pages/RailTesting";
import RailAPI from "../pages/RailAPI";
import ModelTrend from "../pages/ModelTrend";
import AbReport from "../pages/AbReport";
import PrintView from "../pages/PrintView";
import ConfigView from "../pages/RailValidator";
import RailHistory from "../pages/RailHistory";
import RailAnalysis from "../pages/RailAnalysis";
import LLMHallucinationTester from "../pages/LLMHallucinationTester";
import GenerateQuery from "../pages/GenerateQuery";
import PublicQueryTest from "../pages/PublicQueryTest";
import QueryCheck2 from "../pages/QueryCheck2";
import AgenticSafetyEval from "../pages/AgenticSafetyEval";
import HallucinationResultsDashboard from "../pages/HallucinationResultsDashboard";

const AppRoutes = () => (
  <Routes>
    {/* Public route */}
    <Route path="/login" element={<Login />} />
    <Route path="/public-query-check" element={<PublicQueryTest />} />

    {/* Print View Route - No Layout */}
    <Route
      path="/rail-print-view"
      element={
        <ProtectedRoute>
          <PrintView />
        </ProtectedRoute>
      }
    />

    {/* Protected routes */}
    <Route
      path="/"
      element={
        <ProtectedRoute>
          <DashboardLayout />
        </ProtectedRoute>
      }
    >
      <Route index element={<Home />} />
      <Route path="new" element={<NewAssessment />} />
      <Route path="job-explorer" element={<JobExplorer />} />
      <Route path="query-check" element={<QueryCheck2 />} />
      <Route path="hallucination-tester" element={<LLMHallucinationTester />} />
      <Route path="configuration" element={<ConfigModel />} />
      <Route path="risk-management" element={<ConfigCategory />} />
      <Route path="hallucination-categories" element={<HallucinationCategories />} />
      <Route path="assessment-report" element={<AssessmentReport />} />
      <Route path="assessment-report/:scan_id" element={<AssessmentReport />} />
      <Route path="rail-logs" element={<RailLogs />} />
      <Route path="rail-config" element={<RailConfig />} />
      <Route path="rail-testing" element={<RailTesting />} />
      <Route path="rail-api" element={<RailAPI />} />
      <Route path="rail-validator" element={<ConfigView />} />
      <Route path="rail-history" element={<RailHistory />} />
      <Route path="rail-analysis/:scan_id" element={<RailAnalysis />} />
      <Route path="model-trends" element={<ModelTrend />} />
      <Route path="ab-comparison" element={<AbReport />} />
      <Route path="generate-query" element={<GenerateQuery />} />
      <Route path="agentic-safety-eval" element={<AgenticSafetyEval />} />
      <Route path="hallucination-results" element={<HallucinationResultsDashboard />} />

      {/* other nested routes */}
    </Route>
  </Routes>
);

export default AppRoutes;
